import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SectionHeader from '@/components/base/SectionHeader';
import AnimeCard from '@/components/base/AnimeCard';
import { categories } from '@/mocks/category';
import { animeList } from '@/mocks/anime';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const filteredAnime = useMemo(() => {
    if (activeCategory === 'all') return animeList;
    return animeList.filter((a) => a.category === activeCategory);
  }, [activeCategory]);

  return (
    <Layout>
      <div className="pt-24 pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: '分类浏览' }]} />
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">分类浏览</h1>
          <p className="text-sm text-foreground-500 mb-8">按分类筛选你感兴趣的动漫作品</p>

          <div className="flex flex-wrap items-center gap-2 mb-8">
            <button
              onClick={() => setActiveCategory('all')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeCategory === 'all'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              全部
            </button>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-1`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
            {filteredAnime.map((anime) => (
              <AnimeCard key={anime.id} anime={anime} />
            ))}
          </div>

          {filteredAnime.length === 0 && (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类下暂无内容</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}